<template>
  <v-container
    class="pt-4"
    fluid
  >
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="currentSociety"
          :items="socData"
          item-text="name"
          item-value="id_soc"
          :label="$t('akito.account-name')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                :rules="[rules.required]"
                :label="$t('profile.sections.common.name')"
                :disabled="currentSociety == 0"
                dense
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="city"
                :label="$t('status.city')"
                :append-icon="cityOther.length > 0 ? 'mdi-map-marker-multiple' : 'mdi-map-marker-question'"
                :disabled="currentSociety == 0"
                dense
                @input="resetOtherCity()"
                @click:append="setCityInfo()"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="dpt"
                :label="$t('status.department')"
                :disabled="currentSociety == 0"
                readonly
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="lat"
                :label="$t('profile.sections.player.lat')"
                :disabled="currentSociety == 0"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lng"
                :label="$t('profile.sections.player.lng')"
                :disabled="currentSociety == 0"
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10">
              <v-text-field
                v-model="license"
                :rules="[rules.required]"
                :label="$t('profile.sections.player.license')"
                disabled
                readonly
                dense
              />
            </v-col>
            <v-col cols="2">
              <v-btn
                icon
                @click="generateLicense()"
              >
                <v-icon>mdi-autorenew</v-icon>
              </v-btn>
              <v-btn
                icon
                @click="copy()"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="success"
                :disabled="name.length < 1 || license.length < 1 || lat.length == 0 || lng.length == 0"
                @click="createPlayerData()"
              >
                <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("akito.create") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Connectors
import { ProfileSocietyConnector } from "../../Database/ProfileSocietyConnector.js";
const geoApi = require("../../Tools/GeoApi");

// Tools
const { v4: uuidv4 } = require("uuid");

export default {
  data() {
    return {
      societyConnector: new ProfileSocietyConnector(this.$store.state.user),
      currentSociety: 0,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
      },
      socData: [],
      license: "",
      name: "",
      city: "",
      dpt: "",
      lat: "",
      lng: "",
      cityOther: [],
      cityIndex: 0,
    };
  },
  created() {
    this.getSociety();
    this.generateLicense();
  },
  methods: {
    getSociety() {
      this.societyConnector.getSoc().then((response) => {
        this.socData = response;
      });
    },
    generateLicense() {
      this.license = uuidv4();

      this.societyConnector.checkDuplicate(20, this.license, 0).then((duplicate) => {
        if (!duplicate) {
          this.generateLicense();
        }
      });
    },
    copy() {
      // Only work in https
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.license).then(() => {
          //
        });
      } else {
        const dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute("value", this.license);
        dummy.select();
        document.execCommand("copy");
        dummy.remove();
      }
    },
    createPlayerData() {
      const playerData = {
        socId: this.currentSociety,
        name: this.name,
        dpt: this.dpt,
        city: this.city,
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng),
        license: this.license,
      };

      this.societyConnector
        .insertPlayer(playerData)
        .then(() => {
          this.generateLicense();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCityInfo() {
      if (this.cityOther.length > 0) {
        this.cityIndex++;

        if (this.cityIndex >= this.cityOther.length) {
          this.cityIndex = 0;
        }

        this.city = this.cityOther[this.cityIndex].city;
        this.dpt = this.cityOther[this.cityIndex].dpt;
        this.lat = this.cityOther[this.cityIndex].lat;
        this.lng = this.cityOther[this.cityIndex].lng;
      } else {
        const currentCity = this.city;

        if (currentCity.length > 0) {
          geoApi
            .getCityInfo(currentCity)
            .then((response) => {
              if (response.length > 0) {
                if (response.length > 1) {
                  this.cityOther = response.map((elem) => {
                    return {
                      city: elem.nom,
                      dpt: elem.departement.nom,
                      lat: elem.centre.coordinates[1],
                      lng: elem.centre.coordinates[0],
                    };
                  });
                }

                // If only one result
                this.city = response[0].nom;
                this.dpt = response[0].departement.nom;
                this.lat = response[0].centre.coordinates[1];
                this.lng = response[0].centre.coordinates[0];
              } else {
                this.resetCity();
              }
            })
            .catch((err) => {
              console.error(err);
              this.resetCity();
            });
        } else {
          this.resetCity();
        }
      }
    },
    resetCity() {
      this.city = "";
      this.dpt = "";
      this.lat = "";
      this.lng = "";
    },
    resetOtherCity() {
      this.cityOther = [];
      this.cityIndex = 0;
    },
  },
};
</script>

<style></style>
